/** 感染症の種類 */
export const ABSENCE_REASON_DETAIL_INFECTION_TYPE = [
  '新型コロナウイルス感染症',
  'マイコプラズマ',
  '突発性発疹',
  '溶連菌感染症',
  '麻疹',
  '風邪',
  '水痘(水ぼうそう)',
  '流行性耳下腺炎',
  '伝染性紅斑（リンゴ）',
  '百日咳',
  'RSウイルス感染症',
  '手足口病',
  'ヘルパンギーナ',
  '咽頭結膜熱（プール）',
  'アデノウイルス',
  'インフルエンザA',
  'インフルエンザB',
  'マイコプラズマ肺炎',
  '感染性胃腸炎',
  '感染性胃腸炎（ロタ）',
  '感染性胃腸炎（ノロ）',
  '伝染性膿痂疹（とびひ）',
  '伝染性軟属腫（水いぼ）',
  'その他',
] as const;

/** 感染症 */
export type AbsenceReasonDetailInfectionType = typeof ABSENCE_REASON_DETAIL_INFECTION_TYPE[number];
